import { Link } from '@hoffmann/pattern-library-2';

interface MessageProps {
  message: string;
  messageEnd: string;
  linkText: string;
  href: string;
}

export function Message({ message, messageEnd, linkText, href }: MessageProps): JSX.Element {
  return (
    <div>
      {message}&nbsp;
      <Link href={href} target="_blank">
        {linkText}
      </Link>
      {messageEnd}
    </div>
  );
}
